/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FormCustom } from '../../models/form-custom';
import { FormCustomDto } from '../../models/form-custom-dto';

export interface UpdateFormCustom$Params {
  formId: string;
  formCustomId: string;
  body: FormCustomDto;
}

export function updateFormCustom(
  http: HttpClient,
  rootUrl: string,
  params: UpdateFormCustom$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<FormCustom>> {
  const rb = new RequestBuilder(rootUrl, updateFormCustom.PATH, 'put');
  if (params) {
    rb.path('formId', params.formId, {});
    rb.path('formCustomId', params.formCustomId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FormCustom>;
    })
  );
}

updateFormCustom.PATH = '/forms/{formId}/custom/{formCustomId}';
